import {AlertTriangle} from 'lucide-react'

interface GuideBoxProps {
  children: React.ReactNode
}

/**
 * Caixa de orientação em vermelho claro com ícone de atenção.
 * Usada acima de cada seção do modal de detalhes do lead para
 * orientar a consultora sobre como usar aquela seção.
 */
export default function GuideBox({ children }: GuideBoxProps) {
  return (
    <div
      className="flex items-start gap-3 p-4 rounded-xl mb-6"
      style={{
        backgroundColor: '#FEE2E2',
        border: '1px solid #F87171',
      }}
    >
      <div
        className="flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center"
        style={{ backgroundColor: '#EF4444' }}
      >
        <AlertTriangle className="w-4 h-4 text-white" />
      </div>
      <div
        className="text-sm leading-relaxed whitespace-pre-line"
        style={{ color: '#991B1B' }}
      >
        {children}
      </div>
    </div>
  )
}
